// extracted by mini-css-extract-plugin
export default {"title":"AnsQandAUserAll_title__q8eBB","font":"AnsQandAUserAll_font__2jYq0","input":"AnsQandAUserAll_input__lnYXM"};